import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
import { TimelineBlock } from './ui/TimelineBlock';
import { WebinarInfoCard } from './ui/WebinarInfoCard';
import { BonusCard } from './ui/BonusCard';
import { FinalCTABlock } from './ui/FinalCTABlock';
import { TrustpilotReviews } from './ui/TrustpilotReviews';
import { ChatReactions } from './ui/ChatReactions';
import { EmailTestimonial } from './ui/EmailTestimonial';
import { AboutAmee } from './ui/AboutAmee';
export function WebinarDetailsSection() {
  const timelineItems = ['Minuut 1-15: Waarom dominantie averechts werkt', 'Minuut 16-30: Hoe honden natuurlijk communiceren', 'Minuut 31-45: Signalen herkennen en interpreteren', 'Minuut 45-60: In hun taal terugpraten', 'Minuut 60-75: Verrassing', 'Minuut 75-90: Vraag-en-antwoord'];
  return <section className="py-20 mt-12 border-t border-gray-200" data-id="element-187">
      <div className="max-w-[720px] mx-auto px-4 md:px-0 space-y-24" data-id="element-188">
        {/* SECTIE 1: Timeline */}
        <div data-id="element-189">
          <h3 className="text-[#2563EB] font-bold text-3xl mb-10" data-id="element-190">
            Wat er in die 90 minuten precies gebeurt
          </h3>
          <div className="space-y-4" data-id="element-191">
            {timelineItems.map((item, index) => <TimelineBlock key={index} number={index + 1} title={item} data-id="element-192" />)}
          </div>
        </div>

        {/* SECTIE 2: Waarom dit anders is */}
        <div className="prose prose-lg max-w-none prose-headings:font-bold prose-headings:text-gray-900 prose-p:text-gray-700 prose-p:leading-relaxed" data-id="element-193">
          <h3 className="text-3xl mb-6" data-id="element-194">
            Waarom dit anders is dan andere trainingsmethoden
          </h3>
          <p className="mb-6" data-id="element-195">
            Veel hondenscholen focussen op commando's: "Zit", "Af", "Blijf". Dat
            is nuttig, maar het is eenrichtingsverkeer. Jij praat, je hond
            luistert (hopelijk).
          </p>
          <p className="mb-8" data-id="element-196">
            In dit webinar draaien we het om. We leren je luisteren naar wat je
            hond jóu vertelt. Want pas als je begrijpt waarom je hond bepaald
            gedrag vertoont, kun je het structureel oplossen.
          </p>
          <p className="font-medium italic text-xl text-gray-900 border-l-4 border-[#2563EB] pl-6 py-4 bg-blue-50/50 rounded-r-lg" data-id="element-197">
            "Gedrag is geen toeval. Het is communicatie. Als je de taal leert,
            verdwijnt de frustratie." — Amee de Bruijn
          </p>
        </div>

        {/* SECTIE 3: Het moment waarop het kwartje valt */}
        <div data-id="element-198">
          <h3 className="text-gray-900 font-bold text-3xl mb-6" data-id="element-199">
            Het moment waarop het kwartje valt
          </h3>
          <p className="text-gray-700 text-lg mb-10 leading-relaxed" data-id="element-200">
            Voor de meeste deelnemers gebeurt er iets bijzonders rond minuut 20.
            Ineens vallen de puzzelstukjes op hun plek. "O, dus dát bedoelde hij
            toen hij gisteren zo naar me keek!"
          </p>

          <div className="grid gap-8" data-id="element-201">
            <div className="bg-white border border-gray-200 p-8 rounded-xl relative shadow-sm" data-id="element-202">
              <Quote className="text-[#2563EB] w-8 h-8 mb-4 opacity-20" data-id="element-203" />
              <p className="text-gray-700 mb-6 text-lg leading-relaxed" data-id="element-204">
                "Ik dacht altijd dat mijn hond eigenwijs was. Nu zie ik dat hij
                me juist probeerde te kalmeren. Ik voel me bijna schuldig dat ik
                het niet eerder zag, maar ben zo blij dat ik het nu wel snap."
              </p>
              <p className="text-right font-bold text-gray-900 uppercase tracking-wide text-sm" data-id="element-205">
                — Sandra, Utrecht
              </p>
            </div>

            <div className="bg-white border border-gray-200 p-8 rounded-xl relative shadow-sm" data-id="element-206">
              <Quote className="text-[#2563EB] w-8 h-8 mb-4 opacity-20" data-id="element-207" />
              <p className="text-gray-700 mb-6 text-lg leading-relaxed" data-id="element-208">
                "De video-voorbeelden maakten alles duidelijk. Ik herkende mijn
                eigen hond direct in de voorbeelden. De volgende ochtend tijdens
                de wandeling zag ik meteen wat Amee bedoelde."
              </p>
              <p className="text-right font-bold text-gray-900 uppercase tracking-wide text-sm" data-id="element-209">
                — Peter, Rotterdam
              </p>
            </div>
          </div>
        </div>

        {/* SECTIE 4: Trustpilot Reviews */}
        <TrustpilotReviews data-id="element-210" />

        {/* SECTIE 5: Chat Reactions */}
        <ChatReactions data-id="element-211" />

        {/* SECTIE 6: Email Testimonial */}
        <EmailTestimonial data-id="element-212" />

        {/* SECTIE 7: Info Card */}
        <WebinarInfoCard data-id="element-213" />

        {/* SECTIE 8: Primary CTA */}
        <div data-id="element-214">
          <motion.a href="https://stresslessdogs.nl/mc-communiceren" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="block w-full bg-[#2563EB] text-white font-semibold text-center py-5 px-8 rounded-lg shadow-md hover:bg-blue-700 transition-colors text-xl" data-id="element-215">
            RESERVEER MIJN PLEK - GRATIS AANMELDEN
          </motion.a>
        </div>

        {/* SECTIE 9: Bonus Card */}
        <BonusCard data-id="element-216" />

        {/* SECTIE 10: Final CTA */}
        <FinalCTABlock data-id="element-217" />

        {/* SECTIE 11: About/Footer */}
        <AboutAmee data-id="element-218" />
      </div>
    </section>;
}